<template>
  <div class="dtpage-status-float">
    <div class="dsf-item" v-for="item of statusTV" :key="item.name">
      <div
        class="dsf-item--color"
        :style="{
          backgroundColor: detectColorValue(item.value)
            ? item.value
            : `#${item.value}`,
        }"
      ></div>
      <div class="dsf-item--text">{{ item.text }}</div>
    </div>
  </div>
</template>
<script>
import { getInvoiceStatusColor } from "../../modules/accounting/models/color-status";
import { detectColorValue } from "../../utility";

export default {
  props: {
    statusTV: {
      type: Array,
    },
  },
  components: {},
  data: function () {
    return {};
  },
  computed: {},

  methods: {
    getInvoiceStatusColor: getInvoiceStatusColor,
    detectColorValue: detectColorValue,
  },
};
</script>
<style lang="scss">
.dtpage-status-float {
  position: absolute;
  display: flex;
  bottom: 20px;

  padding: 4px;
  background: var(--bc-white);

  box-shadow: 0px 3px 20px #00002433;
  border-radius: 6px;

  .dsf-item {
    display: flex;
    margin: 0px 8px;
    align-items: center;

    &:first-child {
      /* margin-left: 8px; */
    }
    .dsf-item--color {
      margin: 0px 6px;
      width: 5px;
      height: 13px;
      border-radius: 8px;
    }
    .dsf-item--text {
      width: max-content;
    }
  }
}
</style>
